import React, { Fragment, useState, useEffect, useContext } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { toast, Slide } from "react-toastify";
import { appContext } from "../../../Utils/context";
import DatePicker from "react-datepicker";
import Select from "react-select";
import records from "../../../Services/records";
import * as XLSX from "xlsx";
import Loader from "react-loaders";
import SweetAlert from "react-bootstrap-sweetalert";
import Portal from "../../../Utils/portals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrashAlt,
  faSave,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Multiselect } from "react-widgets";
import RecordsDetailed from "../../../DemoPages/Records/Pages/Record_Detail";

import {
  Input,
  Row,
  Col,
  Card,
  CardHeader,
  Button,
  Table,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import List from "../../AppNav/List";

export default function InputSelect() {
  const {
    data,
    setData,
    myLists,
    setMyLists,
    user,
    setAddressId,
    addressId,
    setTagsData,
    tagsData,
    notesData,
    tasksData,
    setTasksData,
    setNotesData,
    setManualAdd,
    manualAdd
  } = useContext(appContext);
  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  // const [alert, setAlert] = useState(false)
  const [selectedItem, setSelectedItem] = useState([]);
  const [propTemperature, setPropTemperature] = useState(" ");
  const [Uid, setUid] = useState(" ");
  const [followUpDate, setFollowUpDate] = useState("");
  const [addressIds, setAddressIds] = useState([]);
  const [tag, setTag] = useState([]);
  const [xyz, setXyz] = useState([]);
  const [ajaxRequesting, setAjaxRequesting] = useState(false)
  const [saveAjaxRequesting, setSaveAjaxRequesting] = useState(false)
  const [selectedList, setSelectedList] = useState([]);
  const [open, setOpen] = useState({});
  const [listName, setListName] = useState("");
  const [alert, setAlert] = useState(false);
  const [recordCount, setRecordCount] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [edit, setEdit] = useState(false);
  const [specificId, setSpecificListId] = useState(null);
  const [listNameForAdd, setListNameForAdd] = useState("")
  // const [list, setList] = useState([])
  let DefaultTags = [
    "Absentee",
    "Bankruptcy",
    "Cash Buyer",
    "Code Violations",
    "Divorce",
    "Eviction",
    "Free and Clear",
    "FRBO",
    "FSBO",
    "High Equity",
    "HOA Liens",
    "Inheritance",
    "Owner Occupied",
    "Out-Of-State",
    "Probate",
    "PreProbate/PreInheritance",
    "Pre-Foreclosure",
    "REO",
    "Skip traced",
    "Tax Lien",
    "Vacant",
    "Vacant Land",
    "Water Shut Off",
  ];

  let qas = "";
  let adID = [];

  useEffect(() => {
    if(show === false){
      setValue('')
    }
  }, [show]);

  useEffect(() => {
    const selectedData = data?.filter((obj) => {
      return obj.checked == true;
    });
    setSelectedItem(selectedData || []);
    // console.log("selected tags", selectedData)
    selectedData?.map((s, k) => {
      qas = qas + s.uat_id + ",";
      adID.push(s.uat_id);
      // setAddressIds([...addressIds, s.address_id])
    });
    setAddressIds(adID);
    //  console.log("AddressId", adID)
    setUid(qas);

    const removeChecked = myLists.map(({ checked, ...rests }) => rests);
    // console.log("remove-checked", removeChecked)
    setMyLists(removeChecked);
  }, [data]);

  useEffect(() => {
    if (propTemperature !== " ") {
      const info = {
        temperature_status: propTemperature,
      };
      const arrayOfItems = selectedItem.map(obj => obj.uat_id)
      let newData = data
      try {
        const promises = [];
        arrayOfItems.forEach(id => {
          promises.push(records
        .addNewTags(id, info)
        .then((res) => {
          const updatedList = newData.map((object) => {
            if (object.uat_id === id) {
              return { ...object, temperature_status: res?.data?.temperature_status };
            }
            return object;
          });
          newData = updatedList
          return res.data;
        })
        .catch((err) => {
          console.log("erroriz ", err);
          return null;
        })
        )
      })
      Promise.all(promises)
    .then(() => {
      setData(newData);
      notify22("Temperature Updated", "success");
    })
    .catch((error) => {
      setAjaxRequesting(false)
      console.error('Error updating Temperature:', error);
    });
      } catch (error) {
        setAjaxRequesting(false)
        console.error('Error:', error);
      }






      // records
      //   .AddTags({
      //     uat_id: Uid?.toString(),
      //     status_type: "temperature_status",
      //     status_value: `{"status": "${propTemperature}"}`,
      //   })
      //   .then((res) => {
      //     // console.log("temprature saved", res.data)
      //     const newList = data.map((obj) => {
      //       if (obj?.checked === true) {
      //         return {
      //           ...obj,
      //           temperature_status: { status: propTemperature },
      //         };
      //       }
      //       return obj;
      //     });
      //     //console.log("new list", newList)
      //     setData(newList);

      //     notify22(
      //       `Property Tempertaure Updated to ${propTemperature} `,
      //       "success"
      //     );
      //   })
      //   .catch((err) => {
      //     console.log("erroriz ", err.response.data.message);
      //   });
    }
  }, [propTemperature]);

  useEffect(()=>{
    if(value == 'Manage Record' && selectedItem.length === 1){
      const newLists = myLists.map(list =>{
        if (selectedItem[0].list_ids.includes(list.id)){
          return { ...list, checked: true };
        }
        return list
      })
      // const newselected = newLists.filter(list=> list.id == selectedItem[0].list_ids)
      const newselected = newLists.filter(list => selectedItem[0].list_ids.includes(list.id));
      setSelectedList(newselected);
      setMyLists(newLists)
    }
    if(value == 'Tags' && selectedItem.length === 1){
      if(selectedItem[0]?.user_tags !== ""){
      setXyz(selectedItem[0]?.user_tags.split(','))}
    }
  },[value])

  const toggleShow = () => {
    if(addressId){
      setShowAlert(true)}
      else if(Object.keys(manualAdd).filter(key => key !== 'people').length > 0){
        setShowAlert(true)
      }
      else{
        close()
      }
  };

  const close=()=>{
    setShow(!show);
    setValue(" ");
    setPropTemperature(" ");
    setTasksData([]);
    setNotesData([]);
    setXyz([]);
    setTagsData({});
    setAddressId("");
    setShowAlert(false)
    const removeChecked = myLists.map(({ checked, ...rests }) => rests);
    setMyLists(removeChecked);
    setSelectedList([]);
  }
  const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,
    });

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    color: "#71879a",
    fontWeight: "bold",
    fontSize: 14,
  };
  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span className="">{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: "40px",
    }),
  };

  const onStatusChange = (status) => {
    if (status !== " ") {
      const info = {
        property_status: {pipeline:status?.group,tag_name:status?.value},
      };
      const arrayOfItems = selectedItem.map(obj => obj.uat_id)
      let newData = data
      try {
        const promises = [];
        arrayOfItems.forEach(id => {
          promises.push(records
        .addNewTags(id, info)
        .then((res) => {
          const updatedList = newData.map((object) => {
            if (object.uat_id === id) {
              return { ...object, property_status: res?.data?.property_status };
            }
            return object;
          });
          newData = updatedList
          return res.data;
        })
        .catch((err) => {
          console.log("erroriz ", err);
          return null;
        })
        )
      })
      Promise.all(promises)
    .then(() => {
      setData(newData);
      notify22("Property Status Updated", "success");
    })
    .catch((error) => {
      setAjaxRequesting(false)
      console.error('Error updating Property Status:', error);
    });
      } catch (error) {
        setAjaxRequesting(false)
        console.error('Error:', error);
      }
  }}

  const addTags = (value) => {
    // Check if there are any values in the 'value' state
    if (value.length !== 0) {
        // Filter out values that are already in the 'tags' state
      let newData = data
      try {
        const promises = [];
        selectedItem.forEach(item => {
          const newtag = value.filter((tag) => !item?.user_tags?.split(',')?.includes(tag));
          const info ={
            user_tags: `${item?.user_tags !== '' ? [item?.user_tags.split(','), ...newtag] : newtag}`}
          
          promises.push(records
        .addNewTags(item?.uat_id, info)
        .then((res) => {
          const updatedList = newData.map((object) => {
            if (object.uat_id === item?.uat_id) {
              return { ...object, tags_count: res.data?.tags_count ,user_tags: res.data?.user_tags };
            }
            return object;
          });
          newData = updatedList
          return res.data;
        })
        .catch((err) => {
          console.log("erroriz ", err);
          return null;
        })
        )
      })
      Promise.all(promises)
    .then(() => {
      setData(newData);
      setValue('')
      setTag([])
      notify22("Tags Added", "success");
    })
    .catch((error) => {
      setAjaxRequesting(false)
      console.error('Error Adding Tags:', error);
    });
      } catch (error) {
        setAjaxRequesting(false)
        console.error('Error:', error);
      }
    } else {
        notify22("Select / Add at least 1 Tag", "warning");
    }
};

const deleteTag = (tagToDelete) => {
  // setDeleteRequesting(true)
  // setParticularTag(tagToDelete)
  const updatedTags = xyz.filter((tag) => tag !== tagToDelete);
  const info ={
      user_tags: `${updatedTags}`
  }

  records
      .addNewTags(selectedItem[0]?.uat_id,info)
      .then((res) => {
          const tagsArray = res.data?.user_tags ? res.data?.user_tags.split(',') : [];
          setXyz(tagsArray);
          const updatedList = data.map((object) => {
            if (object.uat_id === selectedItem[0]?.uat_id) {
              return { ...object, tags_count: res.data?.tags_count , user_tags: res.data?.user_tags };
            }
            return object;
          });
          setData(updatedList)
          notify22("Tags Deleted", "success");
      })
      .catch((err) => {
          console.log("erroriz ", err);
      })
};

  const addFollowDate = async() => {
    if(followUpDate){
      setAjaxRequesting(true)
    const dateObject = new Date(followUpDate);
      const year = dateObject.getUTCFullYear();
      const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0");
      const day = String(dateObject.getUTCDate()).padStart(2, "0");
      const hours = String(dateObject.getUTCHours()).padStart(2, "0");
      const minutes = String(dateObject.getUTCMinutes()).padStart(2, "0");
      const seconds = String(dateObject.getUTCSeconds()).padStart(2, "0");
      const offsetHours = dateObject.getTimezoneOffset() / 60;

      const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${
        offsetHours >= 0 ? "+" : "-"
      }${Math.abs(offsetHours).toString().padStart(2, "0")}:00`;
      const info = {
        follow_up_date: formattedDateString,
      };
      const arrayOfItems = selectedItem.map(obj => obj.uat_id)
      let newData = data
      try {
        const promises = [];
        arrayOfItems.forEach(id => {
          promises.push(records
        .addNewTags(id, info)
        .then((res) => {
          const updatedList = newData.map((object) => {
            if (object.uat_id === id) {
              return { ...object, follow_up_date: res?.data?.follow_up_date };
            }
            return object;
          });
          newData = updatedList
          return res.data;
        })
        .catch((err) => {
          console.log("erroriz ", err);
          return null;
        })
        )
      })
      Promise.all(promises)
    .then(() => {
      setData(newData);
      setFollowUpDate('')
      setShow(false)
      setValue('')
      setAjaxRequesting(false)
      notify22("Follow-UP-Date Updated", "success");
    })
    .catch((error) => {
      setAjaxRequesting(false)
      console.error('Error updating follow-up dates:', error);
    });
      } catch (error) {
        setAjaxRequesting(false)
        console.error('Error:', error);
      }
    }
    else{
      notify22("Please select Date first", "error");
    }
  };

  const clearFollowDate = () => { 
    records
      .AddTags({
        uat_id: Uid.toString(),
        status_type: "follow_up_date",
        status_value: `{"value": ""}`,
      })
      .then((res) => {
        //console.log("Follow Up date clear", res.data)
        setFollowUpDate("");

        const newList = data.map((obj) => {
          if (obj?.checked === true) {
            return { ...obj, follow_up_date: { value: "" } };
          }
          return obj;
        });
        setData(newList);
        notify22("Follow-UP-Date Cleared", "success");
      })
      .catch((err) => {
        console.log("erroriz ", err.response.data.message);
      });
  };

  const handleOnExport = () => {
    let detailedData = [];
    addressIds.map((v, k) => {
      records
        .details(v)
        .then((res) => {
          let mainObj = {};
          mainObj["Decedents Name"] =
            res.data?.lead_info?.inheritance?.full_name;
          mainObj["First Name"] = res.data?.lead_info?.inheritance?.first_name;
          mainObj["Middle Name"] =
            res.data?.lead_info?.inheritance?.middle_name;
          mainObj["Last Name"] = res.data?.lead_info?.inheritance?.last_name;
          mainObj["Phones"] = res.data?.lead_info?.inheritance?.phones
            ?.map((obj) => {
              return obj?.phone;
            })
            .toString();
          mainObj["Emails"] =
            res.data?.lead_info?.inheritance?.emails?.toString();
          mainObj["Date of Birth"] = res.data?.lead_info?.inheritance?.dob;
          mainObj["Date of Death"] = res.data?.lead_info?.inheritance?.dod;
          mainObj["Age"] = res.data?.lead_info?.inheritance?.age;
          mainObj["Property Address"] =
            res.data?.lead_info?.inheritance?.situs_address1;
          mainObj["Property City"] =
            res.data?.lead_info?.inheritance?.situs_city;
          mainObj["Property State"] =
            res.data?.lead_info?.inheritance?.situs_state;
          mainObj["Property Zip"] = res.data?.lead_info?.inheritance?.situs_zip;
          mainObj["Mailing Address"] =
            res.data?.lead_info?.inheritance?.mailing_address1;
          mainObj["Mailing City"] =
            res.data?.lead_info?.inheritance?.mailing_city;
          mainObj["Mailing State"] =
            res.data?.lead_info?.inheritance?.mailing_state;
          mainObj["Mailing Zip"] =
            res.data?.lead_info?.inheritance?.mailing_zip;
          mainObj["Beds"] = res.data?.beds;
          mainObj["Baths"] = res.data?.baths;
          mainObj["Est Value"] = res.data?.est_value;
          mainObj["Property Type"] = res.data?.property_type;
          mainObj["Last Sold Date"] = res.data?.last_sold_date;
          mainObj["Last Sold Price"] = res.data?.last_sold_price;
          mainObj["Builiding Area"] = res.data?.building_area;
          mainObj["Year Built"] = res.data?.year_built;

          res.data?.lead_info?.inheritance?.relatives?.map((rel, k) => {
            mainObj[`Relative#${k + 1}`] =
              rel?.first_name + " " + rel?.last_name;
            mainObj[`Address#${k + 1}`] = rel?.addresses[0]?.address1;
            mainObj[`City#${k + 1}`] = rel?.addresses[0]?.city;
            mainObj[`State#${k + 1}`] = rel?.addresses[0]?.state;
            mainObj[`Zip Code#${k + 1}`] = rel?.addresses[0]?.zip;
            mainObj[`Phone_Number#${k + 1}`] = rel?.phones
              ?.map((obj) => {
                return obj?.phone;
              })
              .toString();
            mainObj[`Email#${k + 1}`] = rel?.emails?.toString();
            mainObj[`Relationship#${k + 1}`] = rel?.associate_type;
          });

          detailedData.push(mainObj);
        })
        .catch((err) => {
          console.log("error is", err);
        });
    });
    //setValue("")
    setTimeout(() => {
      // console.log("listing Deatil", detailedData)
      //console.log("keys are", Object.keys(detailedData[0]))
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(detailedData);
      // ws.A1.s = {
      //   fill: {
      //     patternType: "solid",
      //     fgColor: { rgb: "111111" }
      //   }
      //     };

      XLSX.utils.book_append_sheet(wb, ws, "MySheet1");
      //   var x=2;
      //   detailedData.map((v,k) => {

      //     XLSX.utils.sheet_add_json(wb.Sheets.MySheet1, [detailedData[k]?.lead_info?.inheritance], {origin: k == 0 ?  `BE1`: `BE${x}`, skipHeader: k == 0 ? false: true })
      //     x = x+1;
      //   })

      XLSX.writeFile(wb, "MyExcel.xlsx");

      setValue("");
      setShow(false);
    }, 4000);

    // console.log("selected Data", selectedItem)
    // var wb = XLSX.utils.book_new();
    // var ws = XLSX.utils.json_to_sheet(selectedItem)
    //  XLSX.utils.book_append_sheet(wb, ws, "MySheet1")

    //  XLSX.writeFile(wb, "MyExcel.xlsx")

    //  setValue("")
  };

  const handleCreate = (name) => {
    setTag([...tag,name]);
  };

  const AddMyList = (name) => {
    let newName = name.replaceAll(" ", "-").toLowerCase();
    setMyLists([
      ...myLists,
      {
        id: myLists.length.toString(),
        icon: "pe-7s-folder",
        label: name,
        to: `#/records/${newName}`,
      },
    ]);

    notify22("New List Added", "success");
  };

  const handleList = (val) => {
    setSelectedList(val);  
    var result = myLists?.map(function (o1) {
      o1.checked = false;
      val?.some(function (o2) {
        if (o1?.id === o2?.id) {
          return (o1.checked = true);
        } else {
          return (o1.checked = false);
        }
      });
      return o1;
    }); 
    setMyLists(result);
  };

  const checkChildList = (e) => {
    let listing = myLists;
    listing = listing?.map((d) => {
      if (d?.id == e.target.value) {
        d.checked = e.target.checked;
      }
      return d;
    });

    setMyLists(listing);

    let trackCheck = listing.filter((obj) => obj.checked === true);
    // console.log("trackcheck", trackCheck)
    setSelectedList(trackCheck);
    // trackCheck.length === data.length ? setChecked(true) : setChecked(false)
  };

  const saveListConnection =()=>{
    // if(selectedList.length > 0 && selectedItem.length > 0){
      setSaveAjaxRequesting(true)
    const arrayOfList = selectedList.map(obj => obj.id)
    const arrayOfItem = selectedItem.map(obj => obj.uat_id)
    const info=
      {
        "uat_ids":arrayOfItem.join(',') ,
        "list_ids": arrayOfList.join(',')
        }
        records
      .postListConnection(info).then((res)=>{
                // Assuming 'myObjects' is your array of objects
                const updatedObjects = data.map(obj => {
                  // Check if 'uat_id' exists and is included in the array of items
                  if (arrayOfItem.includes(obj.uat_id)) {
                    // If 'uat_id' exists in the array of items, update the 'list_ids' property
                    return { ...obj, list_ids: arrayOfList };
                  }
                  return obj; // Return the original object if 'uat_id' is not included
                });
                setData(updatedObjects)
        setShow(false)
        setValue('')
        setSaveAjaxRequesting(false)
        notify22("Updated", "success");
        setSelectedList([])
      }).catch((err)=>{
        notify22("Server Error", "error");
        setSaveAjaxRequesting(false)
      })        
  }


  const editMylist = (v) => {
    const info={
      list_name:listName,
      id:v?.id
    }
    records.patchListName(info).then((res)=>{
      const updatedList = myLists.map((obj, k) => {
      if (obj.id === v?.id) {
        return res.data
      }
      return obj
    })
    setMyLists(updatedList)
    handleOpen(v?.id, false)
    setListName("")
    setAlert(false)
    setEdit(false)
    notify22("List Name Updated", "success")
    }).catch((e)=>{
      console.log('error',e.data)
    })
    // const updatedList = myLists.map((obj, k) => {
    //   if (obj.id === v?.id) {
    //     return { ...obj, label: listName };
    //   }
    //   return obj;
    // });

    // setMyLists(updatedList);
    // handleOpen(v?.id, false);
    // setListName("");
    // notify22("List Name Updated", "success");
  };

  const handleOpen = (id, val) => {
    setOpen({ [id]: val });
  };
  const saveRecord = () => {
    setAjaxRequesting(true)
    if(addressId){
    const info = {
      user_id: user?.id,
      address_id: addressId,
      leads: '{"lead_types": ["user_defined"]}',
      source: "OA",
    };
    records
      .addToUat(info)
      .then((res) => {
        if (tagsData) {
          records
            .addNewTags(res.data?.uat_id, tagsData)
            .then((response) => {})
            .catch((e) => {
              console.log("err", e);
            });
        }
        if (notesData) {
          notesData.map((note) => {
            records
              .addNotes({ uat_id: res.data?.uat_id, note: note?.note })
              .then((response) => {})
              .catch((err) => {
                console.log("err", err);
              });
          });
        }
        if (tasksData) {
          tasksData.map((task) => {
            const info = {
              uat_id: res.data?.uat_id,
              action_time: task?.action_time,
              description: task?.description,
              frequency: task?.frequency,
              reminder_source: task?.reminder_source,
              task_name: task?.task_name,
              task_type: task?.task_type,
            };
            records
              .addTask(info)
              .then((response) => {})
              .catch((err) => {
                console.log("err", err);
              });
          });
        }
        setShow(false)
        setTasksData([]);
        setNotesData([]);
        setTagsData({});
        setAddressId("");
        setManualAdd({})
        notify22("Record Successfully Created", "success");
        setShowAlert(false)
        setAjaxRequesting(false)
      })
      .catch((e) => {
        console.log("error", e);
      });}
      else if(Object.keys(manualAdd).filter(key => key !== 'people').length > 0){
        const info={
          ...manualAdd,
          lead_info:{
          user_defined:manualAdd}
        }
        delete info.people;
        records
      .addToAddress(info)
      .then((response)=>{
        // address_id
        const information = {
          user_id: user?.id,
          address_id: response.data.address_id,
          leads: '{"lead_types": ["user_defined"]}',
          source: "OA-2",
        };
        records
          .addToUat(information)
          .then((res) => {
            if (tagsData) {
              records
                .addNewTags(res.data?.uat_id, tagsData)
                .then((response) => {})
                .catch((e) => {
                  console.log("err", e);
                });
            }
            if (notesData) {
              notesData.map((note) => {
                records
                  .addNotes({ uat_id: res.data?.uat_id, note: note?.note })
                  .then((response) => {})
                  .catch((err) => {
                    console.log("err", err);
                  });
              });
            }
            if (tasksData) {
              tasksData.map((task) => {
                const info = {
                  uat_id: res.data?.uat_id,
                  action_time: task?.action_time,
                  description: task?.description,
                  frequency: task?.frequency,
                  reminder_source: task?.reminder_source,
                  task_name: task?.task_name,
                  task_type: task?.task_type,
                };
                records
                  .addTask(info)
                  .then((response) => {})
                  .catch((err) => {
                    console.log("err", err);
                  });
              });
            }
            setShow(false)
            setTasksData([]);
            setNotesData([]);
            setTagsData({});
            setAddressId("");
            setManualAdd({})
            setShowAlert(false)
            setAjaxRequesting(false)
            notify22("Record Successfully Created", "success");
          })
          .catch((e) => {
            console.log("error", e);
          })
      }).catch((e)=>{
        if (e instanceof Error && e.response && e.response.status === 400) {
          notify22('Record Alreadfy exists','error');
        setAjaxRequesting(false)

        } else {
          notify22('Server Error','error');
          console.log(e, 'error');
        setAjaxRequesting(false)

        }
      })
      }
      else{
        notify22("Plaese Add some data first", "error");
        setShowAlert(false)
        setAjaxRequesting(false)
      }
  };

  const deleteList = () => {
    records.deleteListName({id:specificId}).then((res)=>{
      const updatedList = myLists.filter((obj) => {
      return obj.id !== specificId
      })
    setMyLists(updatedList)
    setAlert(false)
    notify22("List Deleted", "success")
    }).catch((e)=>{
      console.log('error',e.data)
    })
  };

  const addList = () => {
    if (listNameForAdd !== "") {
      const info={
        user_id:user.id,
        list_name:listNameForAdd,
        list_type:'user_lists',
        extra:''
      }
      records.postListName(info).then((res)=>{
        setMyLists(res.data)
        setListNameForAdd('')
        notify22("New List Added", "success")
      }).catch((e)=>{
        console.log('error',e.data)
      })
    }else{
      notify22("Add Name First", "error")
    }
  }

  return (
    <Fragment>
     {(user?.allow_record_page || user?.is_staff) && <TransitionGroup>
        <CSSTransition
          component="div"
          classNames="TabsAnimation"
          appear={true}
          timeout={0}
          enter={false}
          exit={false}
        >
          <Row className="header-btn-lg pe-0 ps-2">
            <Col md="12">
              <Input
                type="select"
                bsSize="sm"
                value={value || ""}
                onChange={(e) => {
                  setValue(e.target.value);
                  setShow(true);
                }}
              >
                <option value="" hidden>
                  ACTION
                </option>
                <option className="bg-light text-secondary ">Follow Up</option>
                <option className="bg-light text-secondary">Status</option>
                <option className="bg-light text-secondary">Tags</option>
                <option className="bg-light text-secondary">Manage Record</option>
                <option className="bg-light text-secondary">Manage List</option>
                {user?.is_staff && (
                  <>
                    <option className="bg-light text-secondary">
                      Export Listing
                    </option>
                  </>
                )}
                 <option className="bg-light text-secondary">
                      Add Record
                    </option>
              </Input>
            </Col>
            {value === "Follow Up" &&
              (selectedItem.length !== 0 ? (
                <Modal isOpen={show} toggle={toggleShow}>
                  <Card className="mb-2">
                    <CardHeader className="card-header-tab">
                      <div className="card-header-title font-size-lg text-capitalize fw-normal">
                        <i className="header-icon lnr-calendar-full icon-gradient bg-happy-green">
                          {" "}
                        </i>
                        <span className="menu-header-title text-capitalize">
                          Follow Up
                        </span>
                      </div>
                    </CardHeader>
                  </Card>
                  <ModalBody>
                    <Row className="g-1">
                      <Col md="12">
                      <DatePicker
                                        // id={`follow${k}`}
                                        minDate={new Date()}
                                        // selected={
                                        //   v?.follow_up_date === "" ||
                                        //   v?.follow_up_date === undefined ||
                                        //   v?.follow_up_date === null
                                        //     ? null
                                        //     : new Date(v?.follow_up_date)
                                        // }
                                        selected={followUpDate || ""}
                                        onChange={(date) => {
                                          setFollowUpDate(date);
                                        }}
                                        showTimeSelect
                                        className="form-control"
                                        timeIntervals={5}
                                        dateFormat="MM/dd/yyyy, h:mm aa"
                                        placeholderText="Follow Up Date & Time"
                                        // onCalendarClose={() =>
                                        //   addFollowDate(
                                        //     v?.uat_id,
                                        //     v?.follow_up_date
                                        //   )
                                        // }
                                        />
                        {/* <Datetime
                          dateFormat={"M/D/YYYY,"}
                          timeFormat={"h:mm:ss A"}
                          value={followUpDate || ""}
                          onChange={(e) => {
                            setFollowUpDate(e);
                          }}
                          inputProps={{
                            placeholder: "Follow Up Date & Time",
                          }}
                          renderInput={(props) => {
                            return (
                              <input
                                {...props}
                                value={followUpDate ? props.value : ""}
                              />
                            );
                          }}
                        /> */}
                      </Col>
                      <Col xs="6">
                        <Button
                          block
                          outline
                          className=" btn-wide btn-transition"
                          color="secondary"
                          // onClick={clearFollowDate}
                          onClick={()=>setFollowUpDate('')}
                        >
                          Clear
                        </Button>
                      </Col>
                      <Col xs="6">
                        <Button
                          block
                          outline
                          className=" btn-wide btn-transition"
                          color="primary"
                          disabled={ajaxRequesting}
                          onClick={addFollowDate}
                        >{ ajaxRequesting ?<><Spinner size="sm" /><span className="mb-2">{' '} Saving</span> </>: 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              ) : (
                (notify22("Please Select at least 1 Record", "warning"),
                setValue(""))
              ))}

            {value === "Status" &&
              (selectedItem.length !== 0 ? (
                <Modal isOpen={show} toggle={toggleShow}>
                  <Card className="mb-2">
                    <CardHeader className="card-header-tab">
                      <div className="card-header-title font-size-lg text-capitalize fw-normal">
                        <i className="header-icon lnr-chart-bars icon-gradient bg-happy-green">
                          {" "}
                        </i>
                        <span className="menu-header-title text-capitalize">
                          Status
                        </span>
                      </div>
                    </CardHeader>
                  </Card>
                  <ModalBody>
                    <Row className="g-1">
                      <Col md="12" className="">
                        <Select
                          styles={customStyles}
                          options={selectedItem[0]?.status_setting}
                          formatGroupLabel={formatGroupLabel}
                          onChange={onStatusChange}
                        />
                      </Col>
                      <Col
                        role="button"
                        xs="2"
                        className=" p-2 border rounded-start border-end-0 border-secondary  d-flex justify-content-center align-items-center fw-bold"
                        style={
                          propTemperature === "none"
                            ? { backgroundColor: "#A9A9A9", color: "white" }
                            : { backgroundColor: "#f8f9fa" }
                        }
                        onClick={() => {
                          setPropTemperature("none");
                        }}
                      >
                        None
                      </Col>
                      <Col
                        role="button"
                        xs="2"
                        className="border border-end-0 border-secondary d-flex justify-content-center align-items-center fw-bold"
                        style={
                          propTemperature === "cold"
                            ? { backgroundColor: "#87CEEB", color: "white" }
                            : { backgroundColor: "#f8f9fa" }
                        }
                        onClick={() => setPropTemperature("cold")}
                      >
                        Cold
                      </Col>
                      <Col
                        role="button"
                        xs="2"
                        className="border border-end-0 border-secondary d-flex justify-content-center align-items-center fw-bold"
                        style={
                          propTemperature === "warm"
                            ? { backgroundColor: "#E37383", color: "white" }
                            : { backgroundColor: "#f8f9fa" }
                        }
                        onClick={() => setPropTemperature("warm")}
                      >
                        Warm
                      </Col>
                      <Col
                        role="button"
                        xs="2"
                        className=" border border-end-0 border-secondary  d-flex justify-content-center align-items-center fw-bold"
                        style={
                          propTemperature === "hot"
                            ? { backgroundColor: "#A80000", color: "white" }
                            : { backgroundColor: "#f8f9fa" }
                        }
                        onClick={() => setPropTemperature("hot")}
                      >
                        Hot
                      </Col>
                      <Col
                        role="button"
                        xs="4"
                        className="lh-sm border rounded-end border-secondary d-flex justify-content-center align-items-center fw-bold"
                        style={
                          propTemperature === "Under Contract"
                            ? { backgroundColor: "#228B22", color: "white" }
                            : { backgroundColor: "#f8f9fa" }
                        }
                        onClick={() => setPropTemperature("Under Contract")}
                      >
                        Under Contract
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              ) : (
                (notify22("Please Select at least 1 Record", "warning"),
                setValue(""))
              ))}

            {value === "Manage Record" &&
              (selectedItem.length !== 0 ? (
                <Modal
                  isOpen={show}
                  toggle={toggleShow}
                  style={{ minWidth: "45%" }}
                >
                  <Card className="mb-2">
                    <CardHeader className="card-header-tab">
                      <div className="card-header-title font-size-lg text-capitalize fw-normal">
                        <i className="header-icon lnr-file-add icon-gradient bg-happy-green">
                          {" "}
                        </i>
                        <span className="menu-header-title text-capitalize">
                          Manage Record
                        </span>
                      </div>
                    </CardHeader>
                  </Card>
                  <ModalBody>
                    <Row className="g-1">
                      <Col md="12" className="mb-2">
                        <Multiselect
                          data={myLists}
                          value={selectedList}
                          textField="list_name"
                          placeholder="search / select a List"
                          // allowCreate="onFilter"
                          onChange={(val) => handleList(val)}
                          // onCreate={(name) => AddMyList(name)}
                        />
                      </Col>
                      <Col md="12" style={{height: '300px', overflowY: 'auto'}}>
                        <Table hover size="sm" className="mb-3">
                          <thead>
                                                      <tr>
                                                        <th>#</th>
                                                        <th>List Name</th>
                                                        <th>Listtype</th>
                                                        <th className="text-center">Action</th>
                                                      </tr>
                                                    </thead>
                          <tbody>
                            {myLists?.map((v, k) => (
                              <Fragment key={k}>
                                <tr
                                  style={{
                                    border: "1px solid #E8E8E8",
                                    backgroundColor:
                                      v?.checked == true
                                        ? "#e0f3ff"
                                        : "transparent",
                                  }}
                                >
                                  <td>
                                    <Input
                                      type="checkbox"
                                      id={v.id}
                                      value={v.id}
                                      checked={v?.checked || ""}
                                      onChange={checkChildList}
                                    />
                                  </td>

                                  <td>
                                    {open[v?.id] ? (
                                      <Input
                                        value={
                                          open[v?.id] ? listName : v?.list_name
                                        }
                                        type="text"
                                        onChange={(e) =>
                                          setListName(e.target.value)
                                        }
                                      />
                                    ) : (
                                      v?.list_name
                                    )}
                                  </td>
                                  <td >
                                   {v?.list_type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                                </td>

                                  <td
                                    className="text-center"
                                    style={{ width: "40%" }}
                                  >
                                    {open[v?.id] ? (
                                      <>
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          title="Cancel"
                                          onClick={() => {
                                            handleOpen(v.id, false);
                                            setListName("");
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faTimes}
                                            size="1x"
                                          />{" "}
                                          Cancel
                                        </Button>
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          color="success"
                                          title="Add List"
                                          onClick={() => {setAlert(true);setEdit(v)}}
                                        >
                                          <FontAwesomeIcon
                                            icon={faSave}
                                            size="1x"
                                          />{" "}
                                          Save
                                        </Button>
                                      </>
                                    ) : (
                                      <Button
                                      disabled={v?.list_type !== 'user_lists'}
                                        className="border-0 btn-transition"
                                        outline
                                        color="secondary"
                                        title="Edit List"
                                        onClick={() => {
                                          handleOpen(v.id, true);
                                          setRecordCount(v?.record_count);
                                          setListName(v?.list_name);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPen}
                                          size="1x"
                                        />{" "}
                                        Edit
                                      </Button>
                                    )}
                                    <Button
                                     disabled={v?.list_type !== 'user_lists'}
                                      className="border-0 btn-transition"
                                      outline
                                      color="danger"
                                      title="Delete List"
                                      onClick={() => {
                                        setRecordCount(v?.record_count)
                                        setAlert(true);
                                        setSpecificListId(v?.id);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        size="1x"
                                      />{" "}
                                      Delete
                                    </Button>
                                  </td>
                                </tr>
                              </Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </Col>
                      {myLists.length === 0 && (
                        <Col xs="12" className="text-center mb-2 mt-2">
                          <h6>No Lists to show</h6>
                        </Col>
                      )}
                      <Col xs="6">
                        <Button
                          block
                          outline
                          className=" btn-wide btn-transition"
                          color="secondary"
                          onClick={toggleShow}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col xs="6">
                        <Button
                        onClick={() => saveListConnection()}
                          block
                          outline
                          disabled={saveAjaxRequesting}
                          className=" btn-wide btn-transition"
                          color="primary"
                        >
                       { saveAjaxRequesting ?<><Spinner size="sm" /><span className="mb-2">{' '} Saving</span> </>: 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              ) : (
                (notify22("Please Select at least 1 Record", "warning"),
                setValue(""))
              ))}

{value === "Manage List" &&
                (
                  <List show={show} setShow={setShow} />
             )}



            {value === "Export Listing" &&
              (selectedItem.length !== 0 ? (
                <>
                  {handleOnExport()}
                  <Modal isOpen={show} toggle={toggleShow}>
                    <Card className="mb-2">
                      <CardHeader className="card-header-tab">
                        <div className="card-header-title font-size-lg text-capitalize fw-normal">
                          <i className="header-icon lnr-download icon-gradient bg-happy-green">
                            {" "}
                          </i>
                          <span className="menu-header-title text-capitalize">
                            Export Listing
                          </span>
                        </div>
                      </CardHeader>
                    </Card>
                    <ModalBody>
                      <div className="text-center">
                        <Loader type="ball-pulse-rise" />
                        <h3 className="mt-5">
                          Please wait your file is exporting
                        </h3>
                      </div>
                    </ModalBody>
                  </Modal>
                </>
              ) : (
                (notify22("Please Select at least 1 Record", "warning"),
                setValue(""))
              ))}

            {value === "Tags" &&
              (selectedItem.length !== 0 ? (
                <Modal isOpen={show} toggle={toggleShow}>
                  <Card className="mb-2">
                    <CardHeader className="card-header-tab">
                      <div className="card-header-title font-size-lg text-capitalize fw-normal">
                        <i className="header-icon lnr-tag icon-gradient bg-happy-green">
                          {" "}
                        </i>
                        <span className="menu-header-title text-capitalize">
                          Add Tags
                        </span>
                      </div>
                    </CardHeader>
                  </Card>
                  <ModalBody>
                    <Row className="g-2">
                      <Col xs="12">
                        <Multiselect
                          data={DefaultTags}
                          value={tag}
                          allowCreate="onFilter"
                          placeholder="search or add a new tag"
                          onCreate={(name) => handleCreate(name)}
                          onChange={(value) => {
                            setTag(value);
                          }}
                          textField="name"
                        />
                      </Col>
                      <Col xs="6">
                        <Button
                          block
                          outline
                          className=" btn-wide mb-1 btn-transition"
                          color="secondary"
                          onClick={() => setTag([])}
                        >
                          Clear
                        </Button>
                      </Col>
                      <Col xs="6">
                        <Button
                          block
                          outline
                          className=" btn-wide mb-1 btn-transition"
                          color="primary"
                          onClick={() => {
                            // setXyz(tag);
                            // setTag([]);
                            addTags(tag)
                          }}
                        >
                          Add
                        </Button>
                      </Col>
                      <Col md="12">
                        <h5 className="mb-2">Generated Tags</h5>
                        {xyz?.map((v, k) => (
                          <Fragment key={k}>
                            <span
                              className="badge rounded-pill text-capitalize me-2"
                              style={{ backgroundColor: "#002D62" }}
                            >
                              {v}{" "}
                              <span
                                className="fw-bold ms-2 text-info"
                                role="button"
                                onClick={() => deleteTag(v)}
                              >
                                X
                              </span>
                            </span>
                          </Fragment>
                        ))}
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter></ModalFooter>
                </Modal>
              ) : (
                (notify22("Please Select at least 1 Record", "warning"),
                setValue(""))
              ))}

            {value === "Add Record" && (
              <Modal
                isOpen={show}
                fade={false}
                toggle={toggleShow}
                style={{ minWidth: "99%" }}
              >
                {/* <ModalHeader toggle={toggleShow}>Property Detail</ModalHeader> */}
                <Card>
                  <CardHeader className="card-header-tab z-index-6 d-flex justify-content-between">
                    <div className="card-header-title font-size-lg text-capitalize fw-normal">
                      <i className="header-icon lnr-home icon-gradient bg-happy-green">
                        {" "}
                      </i>
                      <span className="mt-1 ms-1">Add Record</span>
                    </div>
                    <div className="d-inline-flex">
                      {" "}
                      <Button
                        color="success"
                        onClick={saveRecord}
                        block
                        className=""
                      >
                        Save Record
                      </Button>
                      <Button
                        className="mx-2 border-0 btn-transition"
                        outline
                        color="secondary"
                        title=" Cancel"
                        onClick={() => toggleShow()}
                      >
                        <FontAwesomeIcon icon={faTimes} size="2x" />
                      </Button>
                    </div>
                  </CardHeader>
                </Card>
                <ModalBody>
                  <RecordsDetailed />
                </ModalBody>
                <ModalFooter></ModalFooter>
              </Modal>
            )}
            {alert && (
              <Portal id="sweet-alert-portal">
                <SweetAlert
                  title="Are you sure?"
                  show={alert}
                  type={edit? "warning" : "danger"}
                  onConfirm={()=> edit ? editMylist(edit) : deleteList()}
                  onCancel={() => {setAlert(false)}}
                  showCancel
                  confirmBtnText={edit ? "Yes, Update it!" : "Yes, Delete it!"}
                  confirmBtnBsStyle={edit? "warning" : "danger"}
                  cancelBtnBsStyle="info"
                >
                 <span className="fw-bold">This list contains {recordCount} records.</span><br></br>
                  You will not be able to recover this!
                </SweetAlert>
              </Portal>
            )}
                      {showAlert && (
                            <Portal id="sweet-alert-portal">
                                <SweetAlert title="Unsaved Changes Warning" show={showAlert}
                                    type="danger" onCancel={() => saveRecord()}
                                    showCancel 
                                    confirmBtnText={'Cancel Changes'}
                                    onConfirm={close}
                                    cancelBtnText={ajaxRequesting ? <><Spinner size="sm" /><span className="mb-2">{' '} Saving</span> </>
                                    :'Save Changes'}
                                    // confirmBtnText={ajaxRequesting ? <><Spinner size="sm" /><span className="mb-2">{' '} Deleting</span> </>
                                    //     : "Yes, Close It!"} 
                                        confirmBtnBsStyle="danger" cancelBtnBsStyle="info" >
                                          It looks like you have unsaved changes on this page. If you leave without saving, your changes will be lost. 
                                        </SweetAlert>
                            </Portal>
                        )}
          </Row>
        </CSSTransition>
      </TransitionGroup>} 
    </Fragment>
  );
}
